import React from 'react'
import styled from 'styled-components'
import Loader from '../assets/loader.gif'

const ImgDiv = styled.img`
  height: 75px;
  width: 75px;
  @media (min-width: 0px) and (max-width: 600px){
    height: 45px;
    width: 45px;
  }
`

const Spinner = () => (

  <ImgDiv src={Loader} alt="loading..." />

)

export default Spinner
